import { useScreenViewEvent } from '@stitch-fix/event-reporter';
import { useGetClientSelfieQuery } from '../graphql/getClientSelfie';
import { useGetClientFullBodyQuery } from '../graphql/getClientFullBody';
import ProfilePhotosContent from './ProfilePhotosContent';
import { SupportedBusinessLine } from '../Onboarding';
import LoadingScreen from './LoadingScreen';
import OnboardingFailed from '../OnboardingFailed';
import { useGetVisionStatusQuery } from '../../../../utils/hooks/getVisionStatus';
const ProfilePhotos = () => {
  const {
    data: selfieData,
    loading: selfieLoading,
    error: selfieError,
    refetch: refetchSelfie
  } = useGetClientSelfieQuery();
  const {
    data: fullBodyData,
    loading: fullBodyLoading,
    error: fullBodyError,
    refetch: refetchFullBody
  } = useGetClientFullBodyQuery();
  const {
    data: visionStatusData
  } = useGetVisionStatusQuery();
  const {
    EventProvider
  } = useScreenViewEvent({
    schema: 'screen_view',
    name: 'profile_photos',
    source_app: 'categories-next-ui'
  });
  const rawBusinessLine = selfieData?.client?.businessLine || fullBodyData?.client?.businessLine;
  const businessLine: SupportedBusinessLine = rawBusinessLine === 'WOMENS' || rawBusinessLine === 'MENS' ? rawBusinessLine : 'WOMENS';
  if (selfieLoading || fullBodyLoading) {
    return <LoadingScreen />;
  }
  if (selfieError || fullBodyError) {
    return <OnboardingFailed businessLine={businessLine} />;
  }
  const selfieUrl = selfieData?.client?.selfieImageUrl || null;
  const fullBodyImage = fullBodyData?.client?.photoFullBody?.image;
  const fullBodyUrl = fullBodyImage ? `${fullBodyImage.baseUrl}${fullBodyImage.mediaPath}` : null;
  return <EventProvider>
      <ProfilePhotosContent businessLine={businessLine} showSelfieRemovalConfirmation={visionStatusData?.client?.vision?.canAccessVision ?? false} selfie={{
      url: selfieUrl,
      refetch: refetchSelfie
    }} fullBody={{
      url: fullBodyUrl,
      id: fullBodyData?.client?.photoFullBody?.id,
      refetch: refetchFullBody
    }} />
    </EventProvider>;
};
export default ProfilePhotos;